import { render, staticRenderFns } from "./ValidationToggle.vue?vue&type=template&id=2937d37c&scoped=true&"
import script from "./ValidationToggle.vue?vue&type=script&lang=js&"
export * from "./ValidationToggle.vue?vue&type=script&lang=js&"
import style0 from "./ValidationToggle.vue?vue&type=style&index=0&id=2937d37c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2937d37c",
  null
  
)

export default component.exports